import { render, staticRenderFns } from "./MedPadalaModal.vue?vue&type=template&id=c5081834&"
import script from "./MedPadalaModal.vue?vue&type=script&lang=js&"
export * from "./MedPadalaModal.vue?vue&type=script&lang=js&"
import style0 from "./MedPadalaModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports